import { Unidade, UnidadeConversao, UnidadeConversaoSimple } from '../@types';
import aqilaApi from './aqila-api';

class Unidades {
  private readonly endpoint = '/v1/unidades';

  getTaxaFinal(unidade: UnidadeConversaoSimple) {
    return unidade.taxa || unidade.taxaSementes;
  }

  async list() {
    const { data } = await aqilaApi.get<Unidade[]>(this.endpoint);
    return data;
  }

  async find(id: string) {
    const { data } = await aqilaApi.get<Unidade>(`${this.endpoint}/${id}`);

    return data;
  }

  async listConversao(unidadeId: number) {
    const { data } = await aqilaApi.get<UnidadeConversao[]>(
      `${this.endpoint}/unidades_conversao`,
      { params: { unidadeId } },
    );

    return data;
  }

  async getUnidadeKg() {
    const unidades = await this.list();

    return unidades.find((unidade) => unidade.abreviatura.includes('KG'));
  }
}

export default new Unidades();
